import { hot } from 'react-hot-loader/root';
import React from 'react';
import { Provider } from 'react-redux';
import store from './babel/store';
import Routes from 'App/pages/routes';
import AngularApp from './AngularApp';
import Modals from './components/Modals';
import AppOnboarding from 'App/pages/AppOnboarding'; // Rename if not intended to replace current onboarding
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import SystemNotifications from 'Components/SystemNotifications/SystemNotifications';
import { Route, HashRouter as Router } from 'react-router-dom';
import Login from 'App/pages/Login';
import { doStaticSetup } from './helpers/appHelper';
import Session, { onlyRenderWhenAuthenticated } from './Session';
import NavbarComponent from './navbar/Navbar';
import AppSidebarComponent from 'App/components/AppSidebar';
import AIChat from 'App/components/AIChat';
import { useSoftDeployAccess } from './components/hooks/featureHelper';

doStaticSetup();

const Navbar = onlyRenderWhenAuthenticated(NavbarComponent);
const AppSidebar = onlyRenderWhenAuthenticated(AppSidebarComponent);

const AIChatWrapper = () => {
	const hasAIChat = useSoftDeployAccess('AI_CHAT');
	return hasAIChat ? <AIChat /> : null;
};
const App = () => {
	return (
		<Router>
			<Provider store={store}>
				{/* Make Session component handle init and dispatch actions */}
				<Session>
					<Route path="/login" component={Login} />
					<AngularApp>
						<DndProvider backend={HTML5Backend}>
							<div>
								<Navbar />
								<AppSidebar />
								<Routes />
								<Modals />
								<AppOnboarding />
								{/* Port this one to use new modal service later on */}
								<AIChatWrapper />
							</div>
							<SystemNotifications />
						</DndProvider>
					</AngularApp>
				</Session>
			</Provider>
		</Router>
	);
};

export default hot(App);
